module.exports = __webpack_public_path__ + "static/media/RP_safeway.aa5d064c.jpg";